import React, {FunctionComponent, MutableRefObject, useEffect, useState} from 'react';
import styles from './ClusterGroup.module.css';
import {NumberObjectArray} from "../../models/visualisation-data.interface";
import {bubbleChart} from "../../d3/clustered-bubble";
import {HierarchyCircularNode, Simulation} from "d3";
import {getLabels} from "../../helpers/get-labels";
import ClusterChartLabel from "../cluster-chart-label/ClusterChartLabel";
import {AllowedColours} from "../../data/colours";
import ChartLabelExpandedMobile from "../chart-label-expanded-mobile/ChartLabelExpandedMobile";

const height = 400;

const initialExpandedState = [false, false, false];

const ClusterGroup: FunctionComponent<{ dataGroup: NumberObjectArray[], width: number, isLast: boolean }> = (
  {
    dataGroup,
    width,
    isLast,
  }) => {

  const svgRef: MutableRefObject<SVGSVGElement | null> = React.useRef<SVGSVGElement>(null);
  const [labels, setLabels] = useState<{ val: number; oldVal: number; color: AllowedColours; cx: number; cy: number; }[]>([]);
  const [expandedLabels, setExpandedLabels] = useState(initialExpandedState);

  function updateShowExpandedLabels(index: number) {
    const newShowLabels = [...initialExpandedState];
    newShowLabels[index] = true;
    setExpandedLabels(newShowLabels);
  }

  function closeAllLabels() {
    setExpandedLabels(initialExpandedState);
  }

  useEffect(() => {
    setLabels(getLabels(dataGroup, width).filter(({val}) => Boolean(val)));
    closeAllLabels();

    let simulation: Simulation<HierarchyCircularNode<unknown>, undefined> | undefined;

    if (width) {
      const chart = bubbleChart({svgRef, dataGroup, width, height});
      simulation = chart.simulation as Simulation<HierarchyCircularNode<unknown>, undefined>;
    }


    return () => { // Cleanup on destroy
      if (simulation) {
        simulation.stop();
      }
    };
  }, [svgRef, dataGroup, width, isLast]); // Redraw chart if data changes

  return (
    <div className={styles.container}>
      <svg overflow="visible" ref={svgRef} width={width} height={height} style={{transform: "scaleY(-100%)"}} />
      <svg
        overflow="visible"
        width={width}
        height={height}
        style={{transform: "scaleY(-100%)"}}
        className={styles.labels}
      >
        {labels.map(({val, oldVal, color, cx, cy}, i) =>
            <g onClick={() => updateShowExpandedLabels(i)} key={i}>
                <ClusterChartLabel cx={cx} cy={cy} val={val} oldVal={oldVal} color={color} isLast={isLast} width={width} />
            </g>
        )}
      </svg>
      <svg
        overflow="visible"
        width={width}
        height={60}
        style={{transform: "scaleY(-100%)"}}
        className={styles.mobileExpandedLabels}
      >
        {labels.map(({val, oldVal, color}, i) =>
            <g style={{transform: "scaleY(-100%) translateY(-65px)"}} onClick={closeAllLabels} key={i}>
                {expandedLabels[i] && <ChartLabelExpandedMobile {...{val, oldVal, color, width}}/>}
            </g>
        )}
      </svg>
    </div>
  );
}

export default ClusterGroup;
